export const messageObject = {
  SUCCESS: (
    <>
      The previous execution was <strong>SUCCESSFUL</strong>. Do
      you still want to run the execution?
    </>
  ),
  FAILURE: (
    <>
      The previous execution <strong>FAILED</strong>. Do you want to run
      the execution again?
    </>
  ),
  ABORTED: (
    <>
      The previous execution was <strong>ABORTED</strong> by the someone. Do
      you want to run the execution again?
    </>
  ),
  METHOD_CHANGE: (
    <>
      The previous execution was run using <strong>some other</strong> tool. Please create a new iteration to run the execution.
    </>
  ),
  NO_BUILD: (
    <>
      This process will take time depending on the number of test cases in the
      iteration. Are you sure, you want to run the execution for the selected
      iteration?
    </>
  ),
  BUILDING: <>The previous execution is still <strong>RUNNING</strong>. Please wait..</>,
  TRIGGER: (
    <>
      We are triggering the jenkins job to run the execution. Please wait for
      pop up to close automatically.
    </>
  ),
  completed: (
    <>
      The previous execution was <strong>SUCCESSFUL</strong>. Do
      you still want to run the execution?
    </>
  ),
  failure: (
    <>
      The previous execution <strong>FAILED</strong>. Do you want to run
      the execution again?
    </>
  ),
  cancelled: (
    <>
      The previous execution was <strong>ABORTED</strong> by the someone. Do
      you want to run the execution again?
    </>
  ),
  // NO_BUILD: (
  //   <>
  //     This process will take time depending on the number of test cases in the
  //     iteration. Are you sure, you want to run the execution for the selected
  //     iteration?
  //   </>
  // ),
  in_progress: <>The previous execution is still <strong>RUNNING</strong>. Please wait..</>,
  triggering: (
    <>
      We are triggering the github actions workflow to run the execution. Please wait for
      pop up to close automatically.
    </>
  ),
  queued: (
    <>
      The current execution is <strong>QUEUED</strong> and will be triggered soon.
    </>
  ),
};
